const gtag = (..._args: any[]) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push(_args);
};

export default gtag;
